import { initScrollable } from "./features/scrollable";

import { initScrollbarWidth } from "./features/scrollbarWidth";

import { initFilters } from "./features/filters";

import { initFilterShadow } from "./features/filterShadow";

import { initFeedForm } from "./forms/feed";

initScrollable();

initScrollbarWidth();

initFilters();

initFilterShadow();

initFeedForm();

export function initVanilla() {
  initScrollable();

  initScrollbarWidth();

  initFilters();

  initFilterShadow();

  initFeedForm();
}
